import { render, staticRenderFns } from "./default.vue?vue&type=template&id=4810b53b&scoped=true&lang=pug&"
import script from "./default.js?vue&type=script&lang=ts&"
export * from "./default.js?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&id=4810b53b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810b53b",
  null
  
)

export default component.exports